import { Component, OnInit, TemplateRef } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { saveAs } from "file-saver";

@Component({
  selector: "app-patient-review",
  templateUrl: "./patient-review.component.html",
})
export class PatientReviewComponent implements OnInit {
  modalRef: BsModalRef;
  rowsData: any[] = [];
  columnsData: any = [];
  row: any = {};
  destroyComponent: any = {};
  totalItems = 0;
  maxSize = 10;
  maxSizeItem = 10;
  pageOrder: any = {};
  currentPage = 1;
  page: number;
  errorMessage = "";
  constructor(
    private modalService: BsModalService,
    private api: AppService,
    private supportService: SupportService
  ) {}

  ngOnInit() {
    this.getRowsData();
    this.generate();
    this.getColumnOrder();
  }

  openModal(template: TemplateRef<any>) {
    console.log("entered");

    this.modalRef = this.modalService.show(
      template,
      Object.assign({ class: "modal-lg popup-center" })
    );
  }
  private getRowsData() {
    this.rowsData = [
      {
        title: "First Name",
        sorting: true,
        name: "patientFirstName",
        dateFitler: false,
      },
      {
        title: "Last Name",
        sorting: true,
        name: "patientLastName",
        dateFitler: false,
      },
      {
        title: "Star Rating",
        sorting: true,
        name: "rating",
        dateFitler: false,
        starReview: true,
      },
      {
        title: "Date of Service",
        sorting: true,
        name: "scheduledOnStr",
        dateFitler: true,
      },
      {
        title: "Technologist First Name",
        sorting: false,
        name: "technicianFirstName",
        dateFitler: false,
      },
      {
        title: "Technologist Last Name",
        sorting: false,
        name: "technicianLastName",
        dateFitler: false,
      },
      {
        title: "Comments",
        sorting: false,
        name: "review",
        dateFitler: false,
        truncateReview: true,
      },
    ];
    this.row = {
      param1: "patientFirstName",
      param2: "patientLastName",
      param3: "rating",
      param4: "scheduledOnStr",
      param5: "technicianFirstName",
      param6: "technicianLastName",
      param7: "review",
    };
    this.pageOrder = {
      type: "patient",
      pagenumber: 1,
      pagesize: this.maxSizeItem,
      patientType: "all",
      tcId: localStorage.getItem("testCenterId"),
      startDate: "",
      endDate: "",
      sortColumn: "",
      sortType: "",
      search: "",
    };
  }
  private getColumnData(param?, blur?) {
    this.api.getAllReviewByTc(param).subscribe(
      (res: any) => {
        this.columnsData = [];
        if (blur && blur === "blur") {
          this.currentPage = 1;
        }
        if (res && res.entity) {
          this.totalItems = res["count"];
          res.entity.forEach((obj) => {
            const param = this.getParamData(obj);
            this.columnsData.push(param);
          });
        }
      },
      (err) => {
        if (err.error.error === "invalid_token") {
          this.api.sessionOut(err);
        }
      }
    );
  }
  private getParamData(obj) {
    const param: any = {};
    Object.keys(this.row).forEach((key, i) => {
      i = i + 1;
      param["param" + i] = obj[this.row["param" + i]];
    });
    return param;
  }
  private getColumnOrder() {
    this.destroyComponent[
      "orderSubsciber"
    ] = this.supportService.gridSortingHeader.subscribe((result: any) => {
      if (result && (result["name"] || result["order"])) {
        this.pageOrder["sortColumn"] = result["name"];
        this.pageOrder["sortType"] = result["order"];
        this.getColumnData(this.pageOrder);
      }
    });
  }
  ngOnDestroy() {
    Object.keys(this.destroyComponent).forEach((key, i) => {
      if (this.destroyComponent[key]) {
        this.destroyComponent[key].unsubscribe();
      }
    });
  }
  pageChanged(event) {
    this.currentPage = event.page;
    this.pageOrder["pagenumber"] = event.page;
    this.getColumnData(this.pageOrder);
  }
  generate() {
    this.currentPage = 1;
    this.getColumnData(this.pageOrder);
  }
  blurOnChange(ev) {
    if (ev) {
      this.pageOrder["search"] = ev;
      this.pageOrder["pagenumber"] = 1;
      this.getColumnData(this.pageOrder, "blur");
    } else {
      this.pageOrder["search"] = "";
      this.pageOrder["pagenumber"] = 1;
      this.getColumnData(this.pageOrder, "blur");
    }
  }
}
